module.exports = __webpack_public_path__ + "img/alexsToolbox.f7f766f3.png";